var React = require('react');

function User (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M76 84V76C76 71.7565 74.3143 67.6869 71.3137 64.6863C68.3131 61.6857 64.2435 60 60 60H36C31.7565 60 27.6869 61.6857 24.6863 64.6863C21.6857 67.6869 20 71.7565 20 76V84","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M48 44C56.8366 44 64 36.8366 64 28C64 19.1634 56.8366 12 48 12C39.1634 12 32 19.1634 32 28C32 36.8366 39.1634 44 48 44Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

User.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = User;

User.default = User;
